import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as addProjectExternalLink from "./addProjectExternalLink";
import * as editProjectExternalLink from "./editProjectExternalLink";
import * as removeProjectExternalLink from "./removeProjectExternalLink";
import * as retrieveProjectExternalLinks from "./retrieveProjectExternalLinks";

const initialState: State = {
  addProjectExternalLink: addProjectExternalLink.initialState,
  editProjectExternalLink: editProjectExternalLink.initialState,
  removeProjectExternalLink: removeProjectExternalLink.initialState,
  retrieveProjectExternalLinks: retrieveProjectExternalLinks.initialState,
};

const reduceState = combineStateReducer(initialState, {
  addProjectExternalLink: addProjectExternalLink.reduceState,
  editProjectExternalLink: editProjectExternalLink.reduceState,
  removeProjectExternalLink: removeProjectExternalLink.reduceState,
  retrieveProjectExternalLinks: retrieveProjectExternalLinks.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...addProjectExternalLink.createSelector(
      () => getState().addProjectExternalLink,
    ),
    ...editProjectExternalLink.createSelector(
      () => getState().editProjectExternalLink,
    ),
    ...removeProjectExternalLink.createSelector(
      () => getState().removeProjectExternalLink,
    ),
    ...retrieveProjectExternalLinks.createSelector(
      () => getState().retrieveProjectExternalLinks,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
